import React from 'react'
import { useDrag } from 'react-dnd'

import type { DND_TYPE, DragItemType } from '../constant'

type Props = {
  id?: number
  type: DND_TYPE
  children: React.ReactNode
}

type DropItem = DragItemType
type Collect = { isDragging: boolean }

const DragItem = React.memo<Props>(({ id, children, type }) => {
  const [, drag] = useDrag<DragItemType, DropItem, Collect>({
    type,
    item: {
      type,
      // @ts-ignore TO DO: fix (strictNullChecks errors) (https://snapshiftapp.atlassian.net/browse/COP-333)
      id
    },
    previewOptions: {},
    collect: monitor => {
      return {
        isDragging: monitor.isDragging()
      }
    }
  })

  const divRef = React.useRef<HTMLDivElement>(null)
  const combinedRef = React.useCallback(
    (node: HTMLDivElement) => {
      divRef.current = node
      drag(node)
    },
    [drag]
  )

  return <div ref={combinedRef}>{children}</div>
})

export default DragItem
